import {useAppDispatch} from '../../../redux/hooks';
import React, {useEffect} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {GetClasses} from '../../../GraphQL/SystemQueries';
import {
    CreateClass,
    CreateClassFeature,
    DeleteClass, DeleteClassFeature,
    UpdateClass,
    UpdateClassFeature
} from '../../../GraphQL/SystemMutations';
import {toast} from 'react-toastify';
import {setActiveContent, setIsAppLoading} from '../../../redux/slices/content/contentSlice';
import Button from '../../../Atoms/Button';
import {DeleteSharp, PlayArrowSharp} from '@mui/icons-material';
import {PopUp} from '../../../Atoms/PopUp';
import Input from '../../../Atoms/Input';
import {TextEditor} from '../../../Atoms/TextEditor';
import {ActiveContent} from '../../../redux/slices/content/contentType';

import * as _ from 'lodash';
import {toInteger} from 'lodash';
import {Class} from "../../../redux/slices/character/characterType";
import {VeneList} from "../../../Atoms/VeneList";

const emptyClass = {
    classId: 0,
    className: '',
    classDescription: '',
    Mana: [],
    classSpellCast: '',
    hitdie: 0,
    subclassLevel: 0,
    ClassFeature: []
}

export const Klassen = () => {
    const dispatch = useAppDispatch();

    const [ classes, setClasses ] = React.useState<Class[]>([]);
    const [ selectedClass, setSelectedClass ] = React.useState<Class>(emptyClass);
    const [ deleteClassId, setDeleteClassId ] = React.useState<number>(0)
    const [ isPopUpVisible, setIsPopUpVisible ] = React.useState<boolean>(false);
    const [ isDeletePopUpVisible, setIsDeletePopUpVisible ] = React.useState(false)

    const {data: classData, loading: classLoading, error: classError} = useQuery(GetClasses,{fetchPolicy: 'network-only'});
    const [ createClassHook, {}] = useMutation(CreateClass);
    const [ updateClassHook, {}] = useMutation(UpdateClass);
    const [ deleteClassHook, {}] = useMutation(DeleteClass);

    const [ createClassFeatureHook, {}] = useMutation(CreateClassFeature);
    const [ updateClassFeatureHook, {}] = useMutation(UpdateClassFeature);
    const [ deleteClassFeatureHook, {}] = useMutation(DeleteClassFeature);

    useEffect(() => {
        if (classData && !classLoading) {
            setClasses(classData.getClasses);
        }
    }, [ classData ])

    useEffect(() => {
        if (classError) {
            toast('Fehler beim Laden der Völker')
        }
    }, [ classError ])

    useEffect(() => {
        if (classLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Völker werden geladen...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ classLoading ])

    const editClass = (classObj: any) => {
        setSelectedClass({
            Mana: [],
            classId: classObj.classId,
            className: classObj.className,
            classDescription: classObj.classDescription,
            classSpellCast: classObj.classSpellCast,
            hitdie: classObj.hitdie,
            subclassLevel: classObj.subclassLevel,
            ClassFeature: classObj.ClassFeature
        });
        setIsPopUpVisible(true)
    }

    const deleteClass = (classObj: any) => {
        setDeleteClassId(classObj.classId);
        setIsDeletePopUpVisible(true);
    }

    const handleUpdateClass = async () => {
        const updateData = await updateClassHook({
            variables: {
                classId: Number(selectedClass.classId),
                className: selectedClass.className,
                classDescription: selectedClass.classDescription,
                classSpellCast: selectedClass.classSpellCast,
                hitdie: selectedClass.hitdie,
                subclassLevel: selectedClass.subclassLevel,
            },
            refetchQueries: [{
                query: GetClasses
            }]
        })

        if (!updateData.errors) {
            toast(`Das Klasse: ${selectedClass.className} wurde gespeichert!`);
            setSelectedClass(emptyClass);
            setIsPopUpVisible(false);
        } else {
            toast(`Fehler beim Speichern des Volks: ${selectedClass.className}!`)
        }
    }

    const handleCreateClass = async () => {
        const createData = await createClassHook({
            variables: {
                className: selectedClass.className,
                classDescription: selectedClass.classDescription,
                classSpellCast: selectedClass.classSpellCast,
                hitdie: selectedClass.hitdie,
                subclassLevel: selectedClass.subclassLevel,
            },
            refetchQueries: [{
                query: GetClasses
            }]
        })

        if (!createData.errors) {
            toast(`Das Klasse: ${selectedClass.className} wurde erstellt!`);
            setSelectedClass(emptyClass);
            setIsPopUpVisible(false);
        } else {
            toast(`Fehler beim erstellen der Klasse: ${selectedClass.className}!`)
        }
    }

    const handleDeleteClass = async () => {
        const deleteData = await deleteClassHook({
            variables: {
                classId: Number(deleteClassId),
            },
            refetchQueries: [{
                query: GetClasses
            }]
        })

        if (!deleteData.errors) {
            toast(`Das Klasse wurde erfolgreich gelöscht!`)
        } else {
            toast(`Fehler beim Löschen des Volkes!`)
        }

        setDeleteClassId(0);
        setIsDeletePopUpVisible(false);
    }

    const handleClosePopUp = () => {
        setSelectedClass(emptyClass);
        setIsPopUpVisible(false)
    }

    const saveClassFeature = async (classFeature: any) => {
        let response;
        if (classFeature.classFeatureId === 0) {
            response= await createClassFeatureHook({
                variables: {
                    classFeatureName: classFeature.classFeatureName,
                    classFeatureDesc: classFeature.classFeatureDesc,
                    onLevel: toInteger(classFeature.onLevel),
                    classId: toInteger(selectedClass.classId)
                },
                refetchQueries: [{
                    query: GetClasses
                }]
            })
        } else {
            response = await updateClassFeatureHook({
                variables: {
                    classFeatureId: toInteger(classFeature.classFeatureId),
                    classFeatureName: classFeature.classFeatureName,
                    classFeatureDesc: classFeature.classFeatureDesc,
                    onLevel: toInteger(classFeature.onLevel),
                    classId: toInteger(selectedClass.classId)
                },
                refetchQueries: [{
                    query: GetClasses
                }]
            })
        }

        if (response.errors) {
            toast('Fehler beim Speichern des Features')
        } else {
            toast('Feature gespeichert')
        }
    }

    const deleteClassFeature = async(classFeatureId: number) => {
        const response = await deleteClassFeatureHook({
            variables: {
                classFeatureId: toInteger(classFeatureId)
            },
            refetchQueries: [{
                query: GetClasses
            }]
        })

        if (response.errors) {
            toast('Fehler beim Speichern des Features')
        } else {
            toast('Feature gespeichert')
        }
    }

    const renderOneClassFeature = (classFeature: any, index: number) => {
        return (
            <div className='abilityContainer mt-3'>
                <div className='row justify-content-end'>
                    <div className='col-2 text-end'>
                        <Button onClick={ async () => await deleteClassFeature(classFeature.classFeatureId)}>
                            Löschen
                        </Button>
                    </div>
                    <div className='col-2 text-end'>
                        <Button onClick={ async() => await saveClassFeature(classFeature)}>
                            Speichern
                        </Button>
                    </div>
                </div>
                <Input label="Level" type="number" value={classFeature.onLevel} minValue={1} maxValue={20} onChange={(e: any) => {
                    let updatedClassFeature = _.cloneDeep(selectedClass.ClassFeature);
                    updatedClassFeature[index].onLevel = e.target.value;
                    setSelectedClass({
                        ...selectedClass,
                        ClassFeature: updatedClassFeature
                    });
                }}/>
                <Input label="Name" type="text" value={classFeature.classFeatureName} onChange={(e: any) => {
                    let updatedClassFeature = _.cloneDeep(selectedClass.ClassFeature);
                    updatedClassFeature[index].classFeatureName = e.target.value;
                    setSelectedClass({
                        ...selectedClass,
                        ClassFeature: updatedClassFeature
                    });
                }}/>
                <TextEditor label="Beschreibung" onChange={ (e) => {
                    let updatedClassFeature = _.cloneDeep(selectedClass.ClassFeature);
                    if (e != updatedClassFeature[index].classFeatureDesc) {
                        updatedClassFeature[index].classFeatureDesc = e;
                        setSelectedClass({
                            ...selectedClass,
                            ClassFeature: updatedClassFeature
                        });
                    }
                }} value={classFeature.classFeatureDesc}/>
            </div>
        )
    }

    const renderAllClassFeatures = () => {
        const classFeatureHMTL = [];
        let index = 0;
        for (const classFeature of selectedClass.ClassFeature) {
            classFeatureHMTL.push(renderOneClassFeature(classFeature, index));
            index++
        }

        return classFeatureHMTL
    }

    const addNewClassFeature = () => {
        let updatedClassFeatures = _.cloneDeep(selectedClass.ClassFeature);
        updatedClassFeatures.push({
            classFeatureId:   0,
            classFeatureName: '',
            classFeatureDesc: '',
            onLevel:          1
        });
        setSelectedClass({
            ...selectedClass,
            ClassFeature: updatedClassFeatures
        })
    }

    return (
        <div>
            {(isPopUpVisible) && (
                <PopUp onClose={handleClosePopUp} title='Klasse bearbeiten'>
                    <div className='row justify-content-end'>
                        <div className='col-2'>
                            <Button onClick={ async () => selectedClass.classId > 0? await handleUpdateClass() : await handleCreateClass() }>{selectedClass.classId > 0 ? 'Speichern' : 'Erstellen'}</Button>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-2'>
                            Name:
                        </div>
                        <div className='col-10'>
                            <Input value={selectedClass.className} onChange={(e) => setSelectedClass({
                                ...selectedClass,
                                className: e.target.value,
                            })}/>
                        </div>
                        <div className='col-2'>
                            Spellcast:
                        </div>
                        <div className='col-10'>
                            <Input value={selectedClass.classSpellCast} onChange={(e) => setSelectedClass({
                                ...selectedClass,
                                classSpellCast: e.target.value,
                            })}/>
                        </div>
                        <div className='col-2'>
                            Hitdie:
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={0} value={selectedClass.hitdie} onChange={(e) => setSelectedClass({
                                ...selectedClass,
                                hitdie: Number(e.target.value) > 0? Number(e.target.value) : 0,
                            })}/>
                        </div>
                        <div className='col-2'>
                            Subklassen Level:
                        </div>
                        <div className='col-10'>
                            <Input type='number' minValue={0} maxValue={20} value={selectedClass.subclassLevel} onChange={(e) => setSelectedClass({
                                ...selectedClass,
                                subclassLevel: Number(e.target.value) > 0? Number(e.target.value) < 21? Number(e.target.value) : 20 : 0,
                            })}/>
                        </div>
                        <div className='col-2'>
                            Beschreibung:
                        </div>
                        <div className='col-10 mb-4'>
                            <TextEditor value={selectedClass.classDescription} onChange={(value) => setSelectedClass({
                                ...selectedClass,
                                classDescription: value,
                            })}/>
                        </div>
                    </div>
                    <div className='row text-center'>
                        <div className='col-12 text-center'>
                            <b>Klassen-Features:</b>
                        </div>
                    </div>
                    <div className='row mt-4 classFeatureContainer'>
                        <div className='row col-12'>
                            { renderAllClassFeatures() }
                        </div>
                        <div className='col-12'>
                            <Button onClick={ () => addNewClassFeature() }>
                                Hinzufügen
                            </Button>
                        </div>
                    </div>
                </PopUp>
            )}
            {(selectedClass.classId === 0 && !isPopUpVisible) && (
                <div>
                    { isDeletePopUpVisible && (
                        <PopUp onClose={setIsDeletePopUpVisible} title='Klasse löschen'>
                            <div className='row mt-3 justify-content-center'>
                                <div className='col-12'>
                                    <b>Sind sie sicher, dass sie das Klasse löschen möchten?</b>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={ async() => await handleDeleteClass() }>Löschen</Button>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={() => {
                                        setDeleteClassId(0);
                                        setIsDeletePopUpVisible(false)
                                    }}>Abbrechen</Button>
                                </div>
                            </div>
                        </PopUp>
                    )}
                    <div className='row justify-content-between'>
                        <div className='col-2'>
                            <Button onClick={() => dispatch(setActiveContent(ActiveContent.Standardinhalte))}>
                                Zurück
                            </Button>
                        </div>
                        <div className='col-2'>
                            <Button onClick={() => {
                                setSelectedClass({
                                    classId: -1,
                                    className: '',
                                    classDescription: '',
                                    Mana: [],
                                    classSpellCast: '',
                                    hitdie: 0,
                                    subclassLevel: 0,
                                    ClassFeature: []
                                })
                                setIsPopUpVisible(true)
                            }}>
                                Hinzufügen
                            </Button>
                        </div>
                    </div>

                    <VeneList<Class>
                        data={classes}
                        colDefinition={ [
                            {
                                colName: "ID",
                                keyName: "classId",
                            },
                            {
                                colName: "Name",
                                keyName: "className",
                            },
                        ] }
                        buttonConfig={[
                            {
                                icon: <PlayArrowSharp/>,
                                onClick: (dataEntry) => { editClass(dataEntry) }
                            },
                            {
                                icon: <DeleteSharp/>,
                                onClick: (dataEntry) => { deleteClass(dataEntry) }
                            }
                        ]}
                    />
                </div>
            )}
        </div>
    )
}